import React, { useMemo } from "react";
import { useStaticQuery, graphql } from "gatsby";

type LocaleItem = {
  key : string
  ja : string
}

const useLocaleStr = () => {
  const data = useStaticQuery<GatsbyTypes.LocaleStrQuery>(graphql`
  fragment localizedContent on LocaleNode {
    key
    ja
  }

  query LocaleStrQuery{
    common : allCommonCsv {
      nodes {
        ...localizedContent
      }
    }

    common_event : allCommonEventCsv {
      nodes {
        ...localizedContent
      }
    }
    common_datetimeFormat : allCommonDatetimeFormatCsv {
      nodes {
        ...localizedContent
      }
    }

    common_stages : allCommonStagesCsv {
      nodes {
        ...localizedContent
      }
    }

    common_guests : allCommonGuestsCsv {
      nodes {
        ...localizedContent
      }
    }

    common_interval : allCommonIntervalCsv {
      nodes {
        ...localizedContent
      }
    }

    common_activities : allCommonActivitiesCsv {
      nodes {
        ...localizedContent
      }
    }

    common_activityCategory : allCommonActivityCategoryCsv {
      nodes {
        ...localizedContent
      }
    }

    common_photospot : allCommonPhotospotCsv {
      nodes {
        ...localizedContent
      }
    }

    common_footerCopyright : allCommonFooterCopyrightCsv {
      nodes {
        ...localizedContent
      }
    }
    common_footerNav : allCommonFooterNavCsv {
      nodes {
        ...localizedContent
      }
    }
    common_nav : allCommonNavCsv {
      nodes {
        ...localizedContent
      }
    }
    common_satellite : allCommonSatelliteCsv {
      nodes {
        ...localizedContent
      }
    }
    common_social : allCommonSocialCsv {
      nodes {
        ...localizedContent
      }
    }

    common_qrcode : allCommonQrcodeCsv {
      nodes {
        ...localizedContent
      }
    }

    common_utils : allCommonUtilsCsv {
      nodes {
        ...localizedContent
      }
    }

    common_cafe : allCommonCafeCsv {
      nodes {
        ...localizedContent
      }
    }

    common_shop : allCommonShopCsv {
      nodes {
        ...localizedContent
      }
    }

    common_food : allCommonFoodCsv {
      nodes {
        ...localizedContent
      }
    }

    common_sponsors : allCommonSponsorsCsv {
      nodes {
        ...localizedContent
      }
    }


    home_about : allHomeAboutCsv {
      nodes {
        ...localizedContent
      }
    }
    home_activity : allHomeActivityCsv {
      nodes {
        ...localizedContent
      }
    }
    home_countdown : allHomeCountdownCsv {
      nodes {
        ...localizedContent
      }
    }
    home_hero : allHomeHeroCsv {
      nodes {
        ...localizedContent
      }
    }
    home_ingameItem : allHomeIngameItemCsv {
      nodes {
        ...localizedContent
      }
    }
    home_latestInfo : allHomeLatestInfoCsv {
      nodes {
        ...localizedContent
      }
    }
    home_metas : allHomeMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    home_program : allHomeProgramCsv {
      nodes {
        ...localizedContent
      }
    }
    home_promotion : allHomePromotionCsv {
      nodes {
        ...localizedContent
      }
    }
    home_sponsor : allHomeSponsorCsv {
      nodes {
        ...localizedContent
      }
    }
    home_ticket : allHomeTicketCsv {
      nodes {
        ...localizedContent
      }
    }
    home_topics : allHomeTopicsCsv {
      nodes {
        ...localizedContent
      }
    }
    home_souvenir : allHomeSouvenirCsv {
      nodes {
        ...localizedContent
      }
    }

    tickets_metas : allTicketsMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_header : allTicketsHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_concept : allTicketsConceptCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_tickets : allTicketsTicketsCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_requirements : allTicketsRequirementsCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_entry : allTicketsEntryCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_resale : allTicketsResaleCsv {
      nodes {
        ...localizedContent
      }
    }
    tickets_sharing : allTicketsSharingCsv {
      nodes {
        ...localizedContent
      }
    }

    tickets_ticketChart : allTicketsTicketChartCsv{
      nodes {
        ...localizedContent
      }
    }
    

    program_metas : allProgramMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    program_header : allProgramHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    program_stageDay1 : allProgramStageDay1Csv {
      nodes {
        ...localizedContent
      }
    }
    program_stageDay2 : allProgramStageDay2Csv {
      nodes {
        ...localizedContent
      }
    }
    program_subStage : allProgramSubStageCsv {
      nodes {
        ...localizedContent
      }
    }

    

    timetable_metas : allTimetableMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    timetable_header : allTimetableHeaderCsv {
      nodes {
        ...localizedContent
      }
    }

    timetable_streaming : allTimetableStreamingCsv {
      nodes {
        ...localizedContent
      }
    }
    timetable_day1 : allTimetableDay1Csv {
      nodes {
        ...localizedContent
      }
    }
    timetable_day2 : allTimetableDay2Csv {
      nodes {
        ...localizedContent
      }
    }

    contestCampaign_metas : allContestCampaignMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    contestCampaign_header : allContestCampaignHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    contestCampaign_fanart : allContestCampaignFanartCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_metas : allFanartMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_header : allFanartHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_requirements : allFanartRequirementsCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_contestCategory : allFanartContestCategoryCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_votingCategory : allFanartVotingCategoryCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_votingSystem : allFanartVotingSystemCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_nav : allFanartNavCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_finalist : allFanartFinalistCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_winners : allFanartWinnersCsv {
      nodes {
        ...localizedContent
      }
    }
    
    fanart_entries : allFanartEntriesCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ilw_metas : allIlwMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_header : allIlwHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_works : allIlwWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_phw_metas : allPhwMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_header : allPhwHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_works : allPhwWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssa_metas : allSsaMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_header : allSsaHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_works : allSsaWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssu_metas : allSsuMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_header : allSsuHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_works : allSsuWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ilw_winners_metas : allIlwWinnersMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_winners_header : allIlwWinnersHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_winners_works : allIlwWinnersWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_phw_winners_metas : allPhwWinnersMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_winners_header : allPhwWinnersHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_winners_works : allPhwWinnersWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssa_winners_metas : allSsaWinnersMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_winners_header : allSsaWinnersHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_winners_works : allSsaWinnersWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssu_winners_metas : allSsuWinnersMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_winners_header : allSsuWinnersHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_winners_works : allSsuWinnersWorksCsv {
      nodes {
        ...localizedContent
      }
    }


    fanart_ilw_all_metas : allIlwAllMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_all_header : allIlwAllHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ilw_all_works : allIlwAllWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_phw_all_metas : allPhwAllMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_all_header : allPhwAllHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_phw_all_works : allPhwAllWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssa_all_metas : allSsaAllMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_all_header : allSsaAllHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssa_all_works : allSsaAllWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    fanart_ssu_all_metas : allSsuAllMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_all_header : allSsuAllHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    fanart_ssu_all_works : allSsuAllWorksCsv {
      nodes {
        ...localizedContent
      }
    }

    goods_metas : allGoodsMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    goods_header : allGoodsHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    goods_campaign : allGoodsCampaignCsv{
      nodes {
        ...localizedContent
      }
    }

    goods_goods : allGoodsGoodsCsv{
      nodes {
        ...localizedContent
      }
    }

    goods_outsideShop : allGoodsOutsideShopCsv{
      nodes {
        ...localizedContent
      }
    }
    goods_popupShop : allGoodsPopupShopCsv{
      nodes {
        ...localizedContent
      }
    }

    goods_nav : allGoodsNavCsv{
      nodes {
        ...localizedContent
      }
    }

    about_metas : allAboutMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    about_header : allAboutHeaderCsv {
      nodes {
        ...localizedContent
      }
    }
    about_nav : allAboutNavCsv {
      nodes {
        ...localizedContent
      }
    }
    about_schedule : allAboutScheduleCsv{
      nodes {
        ...localizedContent
      }
    }

    about_streaming : allAboutStreamingCsv{
      nodes {
        ...localizedContent
      }
    }

    about_venue : allAboutVenueCsv{
      nodes {
        ...localizedContent
      }
    }

    about_cosplayGuideline : allAboutCosplayGuidelineCsv{
      nodes {
        ...localizedContent
      }
    }

    about_visitorInformation : allAboutVisitorInformationCsv{
      nodes {
        ...localizedContent
      }
    }

    about_entrance : allAboutEntranceCsv{
      nodes {
        ...localizedContent
      }
    }

    about_accessMap_metas : allAccessMapMetasCsv{
      nodes {
        ...localizedContent
      }
    }




    # Added in v1.11.0
    activities_metas : allActivitiesMetasCsv {
      nodes {
        ...localizedContent
      }
    }
    activities_header : allActivitiesHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    activities_ground : allActivitiesGroundCsv{
      nodes {
        ...localizedContent
      }
    }
    activities_activities : allActivitiesActivitiesCsv{
      nodes {
        ...localizedContent
      }
    }

    activities_nav : allActivitiesNavCsv{
      nodes {
        ...localizedContent
      }
    }

    ttrpg_metas : allTtrpgMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    ttrpg_header : allTtrpgHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    ttrpg_requirement : allTtrpgRequirementCsv{
      nodes {
        ...localizedContent
      }
    }
    ttrpg_activities : allTtrpgActivitiesCsv{
      nodes {
        ...localizedContent
      }
    }

    yokero_metas : allYokeroMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    yokero_header : allYokeroHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    yokero_requirement : allYokeroRequirementCsv{
      nodes {
        ...localizedContent
      }
    }
    yokero_activities : allYokeroActivitiesCsv{
      nodes {
        ...localizedContent
      }
    }

    battleChallenge_metas : allBattleChallengeMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    battleChallenge_header : allBattleChallengeHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    battleChallenge_requirement : allBattleChallengeRequirementCsv{
      nodes {
        ...localizedContent
      }
    }
    battleChallenge_reservation : allBattleChallengeReservationCsv{
      nodes {
        ...localizedContent
      }
    }
    battleChallenge_activities : allBattleChallengeActivitiesCsv{
      nodes {
        ...localizedContent
      }
    }

    # Added in v1.14.0
    common_floors : allCommonFloorsCsv{
      nodes {
        ...localizedContent
      }
    }

    floormap_metas : allFloormapMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_header : allFloormapHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_selectTicket : allFloormapSelectTicketCsv{
      nodes {
        ...localizedContent
      }
    }

    floormap_2days_metas : allTwoDaysMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_header : allTwoDaysHeaderCsv{
      nodes {
        ...localizedContent
      }
    }

    floormap_2days_activities : allTwoDaysActivitiesCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_foods : allTwoDaysFoodsCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_maps : allTwoDaysMapsCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_nav : allTwoDaysNavCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_shops : allTwoDaysShopsCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_guide : allTwoDaysGuideCsv{
      nodes {
        ...localizedContent
      }
    }


    floormap_viewing_metas : allViewingMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_header : allViewingHeaderCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_foods : allViewingFoodsCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_maps : allViewingMapsCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_nav : allViewingNavCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_shops : allViewingShopsCsv{
      nodes {
        ...localizedContent
      }
    }

    floormap_viewing_guide : allViewingGuideCsv{
      nodes {
        ...localizedContent
      }
    }



    floormap_viewing_outside_metas : allViewingOutsideMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_viewing_4f_metas : allViewing4FMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_outside_metas : allTwoDaysOutsideMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_ground_metas : allTwoDaysGroundMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_2f_metas : allTwoDays2FMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_1f_out_metas : allTwoDays1FOutMetasCsv{
      nodes {
        ...localizedContent
      }
    }
    floormap_2days_1f_in_metas : allTwoDays1FInMetasCsv{
      nodes {
        ...localizedContent
      }
    }


  }
  `);
  

  const localeData = useMemo(() => {
    let tempLocaleData : any = {};

    Object.keys(data).forEach((namespace) => {
      let arrays = data[namespace].nodes;
      if(arrays.length)
      {
        arrays.forEach((item : LocaleItem) => {
          tempLocaleData[`${namespace}.${item.key}`] = item;
        });
      }
    })

    // console.log(tempLocaleData);

    return tempLocaleData;

  },[]);

  

  return {
    localeData
  }

}


export { useLocaleStr }
